module.exports = __webpack_public_path__ + "media/images/amenities_icons/retail_space-b337cf1312fda992edc3931d990a385f.svg";